import { Box, Flex, SimpleGrid } from '@chakra-ui/react';
import React from 'react';
import Card from '../../components/Card';
import ChartBox from '../../components/ChartBox';


const Page = () => {

    return (

        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >

            <Box>
                <SimpleGrid columns={{ base: 1, md: 4 }} spacing={{ base: 3, lg: 5 }}>
                    <Card title={'Instituições'} stat={'87'} />
                    <Card title={'Crianças'} stat={'123'} />
                    <Card title={'Pedências'} stat={'12'} />
                    <Card title={'Avisos'} stat={'3'} />
                </SimpleGrid>
            </Box>

            <Flex pt="20px">
                <ChartBox width="auto" height="auto" />
            </Flex>

            {/* <Box>
                <tableau-viz id="tableauViz"
                    src="https://public.tableau.com/views/Dashboard-Robo/Alertas?:language=pt-BR&publish=yes&:sid=&:redirect=auth&:display_count=n&:origin=viz_share_link"
                >
                </tableau-viz>
            </Box> */}

        </Flex>
    );
}
export default Page;




